/**
 * Pending Approvals Service
 * Aggregated counts for sidebar / tab badges
 */

import httpClient from '@/utils/httpClient';
import { ENDPOINTS, getEndpointPath } from '@/api/endpoints';

const EMPTY_COUNTS = {
  leaveRequests: 0,
  permissionRequests: 0,
  deviceRequests: 0,
  employeeRequests: 0,
  company: 0,
  total: 0,
};

const pendingApprovalsService = {
  getPendingCounts: async () => {
    try {
      const response = await httpClient.get(
        getEndpointPath(ENDPOINTS.APPROVALS.PENDING_COUNTS)
      );
      if (response.data?.success && response.data?.data) {
        return {
          ...EMPTY_COUNTS,
          ...response.data.data,
        };
      }
      return { ...EMPTY_COUNTS };
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export { EMPTY_COUNTS };
export default pendingApprovalsService;
